import { IonButton, IonCard, IonIcon, IonSkeletonText } from "@ionic/react";
import { useAuthStore } from "../stores/auth.store";
import { useUsersStore } from "../stores/users.store";
import {
  addOutline,
  chevronDown,
  chevronUp,
  walletOutline
} from "ionicons/icons";
import ProfileHeader from "./ProfileHeader";
import { Capacitor } from "@capacitor/core";
import { useEffect, useState } from "react";

export const isNativeIos = () => {
  const platform = Capacitor.getPlatform();
  if (platform === "ios" && Capacitor.isNativePlatform()) {
    return true;
  } else if (platform === "ios") {
    return false;
  } else {
    return false;
  }
};

const ProfileCard: React.FC = () => {
  const [isNative, setIsNative] = useState(false);
  useEffect(() => {
    setIsNative(isNativeIos());
  }, []);

  const currentUserId = useAuthStore(state => state.user?.uid);
  const profile = useUsersStore(state => state.user);
  if (!profile)
    return (
      <IonCard className="bg-primary-50 w-full m-0 h-[170px]">
        <IonSkeletonText animated className="w-full h-full" />
      </IonCard>
    );
  return (
    <IonCard className="bg-primary-50 w-full m-0">
      <div>
        <ProfileHeader profile={profile} />
        {currentUserId === profile?.userId && (
          <>
            <div className="bg-primary-80 p-2 flex items-center justify-between">
              <span className="mx-2 flex items-center">
                <IonIcon
                  icon={walletOutline}
                  className="text-secondary text-3xl"
                />
                <span className="text-lg text-white px-2">Wallet Balance</span>
              </span>
              <span className="text-xl mx-2 font-bold">
                <span className=" text-secondary">
                  {(profile?.quoCoin || 0).toFixed(2)}
                </span>{" "}
                <span className="text-white">QUO</span>
              </span>
            </div>
            <div>
              <div className="h-1 bg-primary-90 w-full"></div>
              <div className="flex justify-between bg-primary-80">
                <IonButton
                  routerLink="/quoCoin/send"
                  fill="clear"
                  className="w-1/3"
                >
                  <IonIcon
                    className="text-secondary text-lg rounded bg-primary-90"
                    icon={chevronUp}
                  ></IonIcon>
                  <div className="text-white pl-2">Send</div>
                </IonButton>
                <div className="w-1 bg-primary-90"></div>
                {!isNative && (
                  <>
                    <IonButton
                      routerLink="/quoCoin/buy"
                      fill="clear"
                      className="w-1/3"
                    >
                      <IonIcon
                        slot="start"
                        className="text-secondary text-lg rounded bg-primary-90"
                        icon={addOutline}
                      ></IonIcon>
                      <div className="text-white pl-2">Buy</div>
                    </IonButton>
                    <div className="w-1 bg-primary-90"></div>
                  </>
                )}
                <IonButton
                  routerLink="/quoCoin/receive"
                  fill="clear"
                  className="w-1/3"
                >
                  <IonIcon
                    slot="start"
                    className="text-secondary text-lg rounded bg-primary-90"
                    icon={chevronDown}
                  ></IonIcon>
                  <div className="text-white">Receive</div>
                </IonButton>
              </div>
            </div>
          </>
        )}
      </div>
    </IonCard>
  );
};

export default ProfileCard;
